import { render } from "./ConnectFanPageDialog.vue?vue&type=template&id=670993af"
import script from "./ConnectFanPageDialog.vue?vue&type=script&lang=js"
export * from "./ConnectFanPageDialog.vue?vue&type=script&lang=js"

import "./ConnectFanPageDialog.vue?vue&type=style&index=0&id=670993af&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__